import { Injectable } from '@angular/core';
import { AbstractDialogService } from '@examdojo/core/dialog';
import { IssueReportDialogComponent } from './issue-report-dialog.component';

const ISSUE_REPORT_DIALOG_ID = 'issue-report';

@Injectable({
  providedIn: 'root',
})
export class IssueReportDialogService extends AbstractDialogService {
  readonly id = ISSUE_REPORT_DIALOG_ID;
  protected readonly component = IssueReportDialogComponent;
}
